import { UserRole } from '../../../shared/enums';

const PermissionsOfProjectDetails = {
  SeeWriterProjectLinks: [UserRole.WRITER],
  SeeEditorProjectLinks: [UserRole.ADMIN, UserRole.EDITOR],
  SeeArchiveProjectIcon: [UserRole.ADMIN],
  SeeDeleteProjectIcon: [UserRole.ADMIN],
  SeeEditProjectIcon: [UserRole.ADMIN],
  SeeOvertakeCheckbox: [UserRole.ADMIN],
  OvertakeProject: [UserRole.ADMIN],
  SeeLinksToAccount: [UserRole.ADMIN, UserRole.EDITOR],
};

export default PermissionsOfProjectDetails;
